import apiClient from './base/apiClient'

export interface MyReferral {
  /** 'TASTEE-7K2Q' 꼴 */
  code: string
  /** 내 코드를 넣고 가입한 사람 수(탈퇴 제외) */
  invitedCount: number
  /** 그중 최근 3명(탈퇴·차단 관계 제외). 친구 초대 화면의 동그라미 세 칸에 쓴다 */
  invited?: { userId: string; nickname: string | null; profileImage: string | null }[]
}

export const referralApi = {
  /** 내 추천인 코드(처음이면 서버가 만든다)와 초대한 친구 수 */
  getMine: async (): Promise<MyReferral> => {
    const res = await apiClient.get<MyReferral>('/referral/me')
    return res.data
  },

  /**
   * 가입 흐름 안에서 계정이 이미 만들어진 뒤 코드를 붙인다(가입 후 1시간 안, 한 번만).
   * 권한 안내 화면에서 뒤로가기로 추천인 화면에 돌아온 경우에 쓴다.
   */
  apply: async (code: string): Promise<{ applied: boolean; message?: string }> => {
    const res = await apiClient.post<{ applied: boolean; message?: string }>(
      '/referral/apply',
      { code },
      { skipErrorHandler: true } as any
    )
    return res.data
  },

  /** 가입 화면에서 코드가 있는지만 확인한다(로그인 전) */
  check: async (code: string): Promise<{ valid: boolean; message: string | null }> => {
    const res = await apiClient.get<{ valid: boolean; message: string | null }>(
      '/referral/check',
      { params: { code }, skipErrorHandler: true } as any
    )
    return res.data
  },
}

/**
 * 초대 링크에 내 추천인 코드를 유입 표시로 붙인다 (2026-11-04).
 *
 * 코드는 campaign(c) 에 넣는다. download.html 이 campaign 이 있을 때만
 * 플레이스토어 referrer(안드로이드는 가입한 계정에 자동으로 붙는다)와
 * 앱스토어 캠페인(ct, 40자 제한 — 코드는 11자)에 넘기기 때문이다.
 * utm_source 는 'invite' 로 고정해 관리자 유입 표에서 친구 초대를 한 갈래로 묶는다.
 */
export const inviteLink = (base: string, code: string | null | undefined): string => {
  const url = base.replace(/\/$/, '')
  if (!code) return url
  // 짧은 이름(s·c)을 쓴다 — download.html 이 utm_source·utm_campaign 과 똑같이 읽고,
  // 메시지에 붙는 링크가 짧아진다(2026-11-04). medium 은 비우면 'referral' 이 된다.
  const q = new URLSearchParams({ s: 'invite', c: code })
  return `${url}?${q.toString()}`
}
